import 'antd/lib/style/index.less';
import './index.less';

// style dependencies
import 'antd/lib/grid/style';
import 'antd/lib/tooltip/style';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@whalecloud/fdx-theme-fdx/simple-form/index.tsx
// module id = 1503
// module chunks = 0